// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_kr-0";
export var fileCarousel = "_kr-2";
export var removeFileButton = "_kr-1";